import React from 'react';

import { Tooltip, ErrorOutlineIcon, colors } from '@gogame/components';

const Reactivity = () => {
  return (
    <Tooltip title={'High ratio of UA/RE Regs detected'}>
      <ErrorOutlineIcon
        style={{ color: colors.orange[500] }}
        sx={{ fontSize: 18 }}
      />
    </Tooltip>
  );
};

export default Reactivity;
